import { AddDeveloperComponent } from "./add-developer/add-developer.component";
import { DevelopersComponent } from "./developers/developers.component";
import { Ng2AutoCompleteModule } from "ng2-auto-complete";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { UiSwitchModule } from "ngx-toggle-switch";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PanelMenuModule } from "primeng/panelmenu";
import { MultiSelectModule } from "primeng/multiselect";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxToggleModule } from "ngx-toggle";
import {
  MatCardModule,
  MatDividerModule,
  MatListModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule,
} from "@angular/material";
import { ModalModule } from "ngx-modal";
import { DropdownModule } from "ngx-dropdown";
import { ToggleButtonModule } from "primeng/togglebutton";
import { DropdownModule as PrimeDropdownModule } from "primeng/dropdown";
import { AngularMultiSelectModule } from "angular2-multiselect-dropdown/angular2-multiselect-dropdown";
import { CurrencyMaskModule } from "ng2-currency-mask";

import { MainSettingsRoutingModule } from "./main-settings-routing.module";
import { MainSettingsComponent } from "./main-settings/main-settings.component";
import { TargetSettingsComponent } from "./target-settings/target-settings.component";
import { GeneralSettingsComponent } from "./general-settings/general-settings.component";
import { ActivityOptionsComponent } from "./activity-options/activity-options.component";
import { ChannelsOptionsComponent } from "./channels-options/channels-options.component";
import { PaymentTermsComponent } from "./payment-terms/payment-terms.component";
import { CfoPinComponent } from "./cfo-pin/cfo-pin.component";
import { AddTargetComponent } from "./target-settings/add-target/add-target.component";
import { BranchesComponent } from "./branches/branches.component";
import { AddBranchComponent } from "./branches/add-branch/add-branch.component";
import { TeamsComponent } from "./teams/teams.component";
import { AddTeamComponent } from "./teams/add-team/add-team.component";
import { AccountsComponent } from "./accounts/accounts.component";
import { AddAccountComponent } from "./accounts/add-account/add-account.component";
import { SetupPaymentPlansComponent } from "./setup-payment-plans/setup-payment-plans/setup-payment-plans.component";
import { OnlyNumbersDirective } from "../directives/only-numbers.directive";
import { PercentagePipe } from "../pipes/percentage.pipe";

import { MatExpansionModule } from "@angular/material/expansion";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { ContractsComponent } from "./contracts/contracts.component";
import { AddContractComponent } from "./contracts/add-contract/add-contract.component";
import { AddTicketSettingsComponent } from "./add-ticket-settings/add-ticket-settings.component";
import { AddDepartmentTicketsComponent } from "./add-department-tickets/add-department-tickets.component";
import { DepartmentsComponent } from "./departments/departments.component";
import { ReminderOptionsComponent } from "./reminder-options/reminder-options.component";
import { OccasionsComponent } from "./occasions/occasions.component";
import { AddOccasionComponent } from "./add-occasion/add-occasion.component";
import { CustomOccasionsComponent } from "./custom-occasions/custom-occasions.component";
import { SystemVersionComponent } from "./system-version/system-version.component";
import { RolesComponent } from "./roles/roles.component";
import { AddRoleComponent } from "./roles/add-role/add-role.component";
import { AddPermissionComponent } from "./roles/add-role/add-permission/add-permission.component";
import { AddMetaComponent } from "./roles/add-role/add-meta/add-meta.component";
import { EventsExpeditionComponent } from "./events-expedition/events-expedition.component";
import { EventsExpeditionService } from "./../services/settings-service/events-expedition.service";
import { NgSelectModule } from "@ng-select/ng-select";
import { HeaderModule } from "../layout/header/header.module";
import { StoreBanksComponent } from './store-banks/store-banks.component';
import { AddStoreBankComponent } from './add-store-bank/add-store-bank.component';
import { CustomerBanksComponent } from './customer-banks/customer-banks.component';
import { AddCustomerBankComponent } from './add-customer-bank/add-customer-bank.component';
import { PartnerComponent } from './partner/partner.component';
import { AddPartnerComponent } from './add-partner/add-partner.component';
import { ViewPaymentTermComponent } from './view-payment-term/view-payment-term.component';
import { AddNationalityComponent } from './add-nationality/add-nationality.component';
import { ViewNationalityComponent } from './view-nationality/view-nationality.component';
import { ShareHoldersService } from "../services/share-holders/share-holders.service";
import { ShareHoldersComponent } from "./share-holders/share-holders.component";
import { TranslateModule } from "@ngx-translate/core";
import { LeadActionsComponent } from "./lead-actions/lead-actions.component";
import { MortageControlComponent } from "./mortage-control/mortage-control.component";
import { DndListModule } from "ngx-drag-and-drop-lists";

@NgModule({
  imports: [
    // CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PanelMenuModule,
    MultiSelectModule,
    NgbModule.forRoot(),
    NgxToggleModule,
    DropdownModule,
    PrimeDropdownModule,
    ModalModule,
    ToggleButtonModule,
    MatCardModule,
    AngularMultiSelectModule,
    CurrencyMaskModule,
    MainSettingsRoutingModule,
    UiSwitchModule,
    NgMultiSelectDropDownModule.forRoot(),
    Ng2AutoCompleteModule,
    MatExpansionModule,
    MatCheckboxModule,
    MatTooltipModule,
    MatListModule,
    MatDividerModule,
    MatTabsModule,
    MatTableModule,
    MatSortModule,
    NgSelectModule,
    HeaderModule,
    TranslateModule,
    DndListModule,
  ],
  declarations: [
    MainSettingsComponent,
    TargetSettingsComponent,
    GeneralSettingsComponent,
    ActivityOptionsComponent,
    ChannelsOptionsComponent,
    PaymentTermsComponent,
    CfoPinComponent,
    AddTargetComponent,
    BranchesComponent,
    AddBranchComponent,
    TeamsComponent,
    AddTeamComponent,
    AccountsComponent,
    // AddAccountComponent,
    SetupPaymentPlansComponent,
    OnlyNumbersDirective,
    PercentagePipe,
    ContractsComponent,
    AddContractComponent,
    AddTicketSettingsComponent,
    AddDepartmentTicketsComponent,
    DepartmentsComponent,
    ReminderOptionsComponent,
    OccasionsComponent,
    AddOccasionComponent,
    CustomOccasionsComponent,
    SystemVersionComponent,
    RolesComponent,
    AddRoleComponent,
    AddPermissionComponent,
    AddMetaComponent,
    EventsExpeditionComponent,
    DevelopersComponent,
    AddDeveloperComponent,
    StoreBanksComponent,
    AddStoreBankComponent,
    CustomerBanksComponent,
    AddCustomerBankComponent,
    PartnerComponent,
    AddPartnerComponent,
    ViewPaymentTermComponent,
    AddNationalityComponent,
    ViewNationalityComponent,
    ShareHoldersComponent,
    LeadActionsComponent,
    MortageControlComponent
  ],
  providers: [EventsExpeditionService, ShareHoldersService],
})
export class MainSettingsModule {}



// WEBPACK FOOTER //
// ./src/app/main-settings/main-settings.module.ts